import React from "react";
import styled from "styled-components";

const Container = styled.div`
  text-align: center;
  padding: 100px;
  background: linear-gradient(120deg, #f6d365 0%, #fda085 100%);
  color: white;
`;

const Heading = styled.h1`
  font-size: 4rem;
`;

const SubHeading = styled.p`
  font-size: 1.5rem;
  margin: 20px 0;
`;

const Home = () => {
  return (
    <Container>
      <Heading>Welcome to MuseMatch</Heading>
      <SubHeading>Your creative platform to showcase and sell art.</SubHeading>
      {/* Add more content like Call to Action buttons or Image */}
    </Container>
  );
};

export default Home;
